import React, { Fragment, useEffect, useState } from "react";
import './adminTest.scss';
import Snackbar from '@mui/material/Snackbar';
import Select, { components } from 'react-select';
import QuestionList from "./questionList";
import { useHistory, withRouter } from "react-router-dom/cjs/react-router-dom.min";
import AddQuestions from "./addQuestions";
import { resetQuestionData, savedQuestions, getDataForEdit, editedQuestion, deleteQuizQuestions, addCustomTest, editCustomTest, addQuiz, updateQuiz, getSkills } from "../../../ActionCreators/AdminAction/adminTestAction";
import { clearErrors } from "../../../ActionCreators/errorAction";
import { connect, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import Modal from 'react-bootstrap/Modal';

const DropdownIndicator = props => {
    return (
        <components.DropdownIndicator {...props}>
            <img src='/images/select-indicator.svg' alt='' />
        </components.DropdownIndicator>
    );
};


function AddQuiz(props) {
    const [testTitle, setTestTitle] = useState('');
    const [duration, setDuration] = useState('');
    const [skill, setSkill] = useState('');
    const [quizType, setQuizType] = useState('');
    const [testId, setTestId] = useState('');
    const [isShowList, setIsShowList] = useState(false);
    const [titleError, setTitleError] = useState('');
    const [durationError, setDurationError] = useState('');
    const [typeError, setTypeError] = useState('');
    const [skillError, setSkillError] = useState('');
    const [isQuestionVisible, setIsQuestionVisible] = useState(false);
    const [isQuestionListVisble, setIsQuestionListVisble] = useState(false);
    const [questionError, setQuestionError] = useState('');
    const [isConfirm, setIsConfirm] = useState(false);
    const times = [10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 70, 80, 90, 100]
    const typeForSelect = [
        { value: 'MCQ', label: 'Multiple choice question' },
        // { value: 'Subjective', label: 'Long answer' }
    ]


    const history = useHistory();
    const dispatch = useDispatch();


    useEffect(() => {
        props.getSkills();
        const { details, edit, type } = history.location.state
        console.log(details)
        if (details !== undefined && edit) {
            setTestTitle(details.title);
            setDuration(Math.round(details?.time / 60));
            setSkill({ label: details?.skill?.title, value: details?.skill?._id });
            setTestId(details._id);
            setQuizType(type !== 'question' && details?.questions[0]?.type === 'MCQ' ? { label: 'Multiple choice question', value: 'MCQ' } : { label: 'Long answer', value: 'Subjective' });
            setIsShowList(true);
        }
        return (() => {
            props.deleteQuizQuestions();
        })

    }, [])

    useEffect(() => {
        dispatch(getDataForEdit(history.location.state?.details));
    }, [history.location.state?.edit && props.qTitle === ''])



    const onChangeQuiZTitle = (val) => {
        setTestTitle(val);
        setTitleError('');
    };

    const onChangeSkill = (e) => {
        setSkill(e);
        setSkillError('');
    };

    const onChangeType = (e) => {
        setQuizType(e);
        setTypeError('');
    }



    const onChangeDuration = (val) => {
        setDuration(val);
        setDurationError('');
    };

    const saveCustomTest = async () => {
        if (testTitle.trim() === "" || null) {
            setTitleError(`title can't empty`);
        }
        else if (skill?.value === "" || null) {
            setSkillError(`skill can't be empty`);
        }
        else if (duration.trim() === "" || null) {
            setDurationError(`duration can't be empty`);
        }
        else if (props.questionListForQuiz?.length === 0 || null) {
            setQuestionError("please select the questions");
        } else {
            setTitleError('');
            setSkillError('');
            setDurationError('');
            setQuestionError('');
            const obj = {
                title: testTitle,
                time: duration * 60,
                skill_id: skill?.value,
                q_ids: props.questionListForQuiz.map(el => el._id),
            };
            console.log(obj)
            await props.addCustomTest(obj);
            await backToMain();
        }
    };

    const editCustomTest = async () => {
        if (testTitle === "") {
            setTitleError(`title can't empty`)
        }
        else if (skill === "") {
            setSkillError(`skill can't be empty`);
        }
        else if (duration === '') {
            setDurationError(`duration can't be empty`);
        }
        else if (props.questionListForQuiz?.length === 0 || null) {
            setQuestionError("please select the questions");
        }
        else {
            setTitleError('');
            setSkillError('');
            setDurationError('');
            setQuestionError('');
            const obj = {
                _id: testId,
                title: testTitle,
                time: duration * 60,
                skill_id: skill?.value,
                q_ids: props.questionListForQuiz.map(el => el._id)
            };
            await props.editCustomTest(obj);
            await backToMain();
        }
    }

    const saveQuiz = async () => {
        if (testTitle.trim() === "" || null) {
            setTitleError(`title can't empty`);
        }
        else if (skill?.value === "" || null) {
            setSkillError(`skill can't be empty`);
        }
        else if (props.questionListForQuiz?.length === 0 || null) {
            setQuestionError("please select the questions");
        } else {
            setTitleError('');
            setSkillError('');
            setQuestionError('');
            const obj = {
                title: testTitle,
                skill_id: skill?.value,
                q_ids: props.questionListForQuiz.map(el => el._id),
            };
            await props.addQuiz(obj);
            await backToMain();
        }
    }

    const editQuiz = async () => {
        if (testTitle === "") {
            setTitleError(`Title can't empty`)
        }
        else if (skill === "") {
            setSkillError(`Skill can't be empty`);
        }
        else if (props.questionListForQuiz?.length === 0 || null) {
            setQuestionError("please select the questions");
        }
        else {
            setTitleError('');
            setSkillError('');
            setQuestionError('');
            const obj = {
                _id: testId,
                title: testTitle,
                skill_id: skill?.value,
                q_ids: props.questionListForQuiz.map(el => el._id)
            };
            await props.updateQuiz(obj);
            await backToMain();
        }
    }

    const showQuizList = () => {
        if (testTitle.trim() === "" || null) {
            setTitleError(`Title can't empty`)
        }
        else if (skill === "" || null) {
            setSkillError(`Skill can't be empty`);
        }
        else if (history.location.state.type === 'test' && (duration.trim() === "" || null)) {
            setDurationError(`Duration can't be empty`);
        }
        else if (quizType === "" || undefined) {
            setTypeError("type cannot be empty");
        }
        else {
            setIsShowList(true);
        }
    }

    const backToMainList = () => {
        setIsQuestionVisible(false);
    };

    const backToList = () => {
        setIsQuestionListVisble(false);
    };


    const backToMain = () => {
        history.goBack();
    }


    const { type, edit, details } = history.location.state
    const { skillList, theme } = props
    return (
        <Fragment>
            {/* <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                open={props.successEnable}
                onClose={() => props.snackClosed()}
                message={props.successMessageText}
                autoHideDuration={4000}
            /> */}

            {
                type === 'question' ? (
                    <AddQuestions
                        type={type}
                        backToMain={backToMain}
                        resetQuestionData={props.resetQuestionData}
                        savedQuestions={props.savedQuestions}
                        editedQuestion={props.editedQuestion}
                        successEnable={props.successEnable}
                        successMessageText={props.successMessageText}
                        snackClosed={props.snackClosed}
                        skillList={props.skillList}
                        questions={details}
                        getQuestionFromSkill={props.getQuestionFromSkill}
                        // questions={props.editQuestionData}
                        isAddfromQuiz={false}
                        edit={edit}
                        theme={theme}
                    />
                ) :
                    isQuestionVisible === true ? (
                        <AddQuestions
                            type={"question"}
                            backToMain={() => backToMainList()}
                            resetQuestionData={props.resetQuestionData}
                            isAddfromQuiz={true}
                            savedQuestions={props.savedQuestions}
                            skillList={props.skillList}
                            qType={quizType?.value}
                            skill={skill}
                            theme={theme}
                        />
                    ) : isQuestionListVisble ? (
                        <QuestionList
                            backToMain={() => backToList()}
                            type="selectQuestion"
                            selectType={quizType?.value}
                            skillList={props.skillList}
                            skill={skill}
                            theme={theme}
                        />
                    ) : (
                        <>
                            <div div className="practise">
                                <div className="d-flex justify-content-between align-items-center">
                                    <h2 style={{ marginLeft: 0 }}>
                                        {(isShowList && edit) ?
                                            <img src="/images/back1.svg" width="20px" alt="" onClick={() => history.goBack()} /> :
                                            isShowList ?
                                                <img src="/images/back1.svg" width="20px" alt="" onClick={() => props.questionListForQuiz?.length ? setIsConfirm(true) : setIsShowList(false)} /> :
                                                <img src="/images/back1.svg" width="20px" alt="" onClick={() => history.goBack()} />}
                                        {type === 'quiz' ? (edit ? 'Edit Quiz' : 'Add Quiz') : (edit ? 'Edit Custom Test' : 'Add Custom Test')}
                                    </h2>
                                    {
                                        isShowList ?
                                            <button style={{ backgroundColor: theme?.bgColor }}
                                                onClick={() => type === 'test' ? (edit ? editCustomTest() : saveCustomTest()) :
                                                    (edit ? editQuiz() : saveQuiz())
                                                }
                                            >
                                                Save Quiz<span class="arrow-right"></span>{" "}
                                            </button>
                                            : null
                                    }
                                </div>
                                <>
                                    <div className="form-group mt-2 w-100 practice-form">
                                        <label>{type === 'quiz' ? 'Quiz Title' : 'Test Title'}</label>
                                        <input
                                            className="form-control mt-2  w-100"
                                            value={testTitle}
                                            onChange={(e) => onChangeQuiZTitle(e.target.value)}
                                        />
                                        <small>{titleError}</small>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <div className="form-group mt-2  mr-3 w-100">
                                            <label>Skill</label>
                                            <Select
                                                components={{ DropdownIndicator }}
                                                options={skillList.map(el => [{ label: el.title, value: el._id }][0])}
                                                onChange={onChangeSkill}
                                                className='selectSub'
                                                placeholder='Select Skill'
                                                value={skill}
                                                isDisabled={isShowList ? true : false}
                                            >
                                            </Select>
                                            <small>{skillError}</small>
                                        </div>
                                        <div className="form-group mt-2 mr-3 w-100 ">
                                            <label>Question type</label>
                                            <Select
                                                components={{ DropdownIndicator }}
                                                options={typeForSelect}
                                                onChange={onChangeType}
                                                className='selectSub'
                                                placeholder='Select Type'
                                                value={quizType}
                                                isDisabled={isShowList ? true : false}
                                            >
                                            </Select>

                                            <small>{typeError}</small>
                                        </div>
                                        {type === 'test' &&
                                            <div className="form-group mt-2  w-100 ">
                                                <label>Test Duration(mins)</label>
                                                <select
                                                    className="form-control mt-2 w-100"
                                                    // style={{ width: "85%" }}
                                                    id='duration'
                                                    value={duration}
                                                    onChange={(e) => onChangeDuration(e.target.value)} >
                                                    <option hidden>Select duration</option>
                                                    {
                                                        times !== undefined && times.map(el => {
                                                            return (
                                                                <option key={el} value={el}>{el}</option>
                                                            )
                                                        })
                                                    }

                                                </select>
                                                <small>{durationError}</small>
                                            </div>}
                                    </div>

                                    {!isShowList ?
                                        <button style={{ backgroundColor: theme?.bgColor }} onClick={showQuizList}>
                                            Save
                                        </button>
                                        :
                                        <div className="form-group mt-2">
                                            <label className="pb-2">Test Questions</label>
                                            <div className="addpointer  d-flex align-items-center">
                                                <button style={{ backgroundColor: theme?.bgColor }}
                                                    className=""
                                                    onClick={() => setIsQuestionListVisble(true)}
                                                >
                                                    Select from list
                                                </button> &nbsp; &nbsp;
                                                <button
                                                    style={{ background: 'none', border: '1px solid #8b7df2', color: '#8b7df2' }}
                                                    onClick={() => {
                                                        props.resetQuestionData()
                                                        setIsQuestionVisible(true)
                                                    }}
                                                >
                                                    Add new question
                                                </button>
                                            </div>
                                            <small>{questionError}</small>
                                        </div>
                                    }

                                </>
                            </div>
                            {
                                !isShowList ? null :
                                    <Fragment>
                                        <div className="selected-count">
                                            {" "}
                                            <h4>
                                                Selected Questions ({props.questionListForQuiz?.length})
                                            </h4>
                                        </div>
                                        <div div className="">
                                            <QuestionList />
                                        </div>
                                    </Fragment>
                            }

                        </>
                    )}
            {/* ########## Confirm  modal ############### */}
            <Modal
                show={isConfirm}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                dialogClassName={"confirm-modal"}
            >
                <div className="p-3 text-center">
                    <h1 style={{ fontSize: 18 }}>Oops! Looks like you haven't saved the changes.Please save the changes</h1>
                    <div className="text-center d-flex flex-column align-items-center p-2 ">
                        <p className="text-capitalize"></p>
                    </div>
                    <div className="save-btn">
                        <button onClick={() => saveQuiz()} >Save</button> &nbsp;&nbsp;
                        <button onClick={() => setIsConfirm(false)}>Cancel</button>
                    </div>
                </div>
            </Modal>
        </Fragment>
    );
}


const mapStateToProps = (state) => {
    const { activeBtn, isTestLoading, testList, v2TestList, credit_points,
        skillList, questionListForQuiz, quizzes } = state.adminTest
    const { successEnable, successMessage, successMessageText } = state.error
    const { theme } = state.account
    return {
        activeBtn, isTestLoading, testList, v2TestList, credit_points,
        skillList, questionListForQuiz, quizzes,
        theme,
        successEnable, successMessage, successMessageText
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ savedQuestions, getDataForEdit, editedQuestion, resetQuestionData, deleteQuizQuestions, addCustomTest, editCustomTest, addQuiz, updateQuiz, getSkills, clearErrors }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AddQuiz))

